import { Publisher } from "../organization/organization";

export class GeneralInformation {
  publisher: Publisher | undefined;
  customerContact: string;
  bpgContact: string;
  date: string;

  constructor() {
    this.publisher = undefined;
    this.bpgContact = "";
    this.customerContact = "";
    this.date = new Date().toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  }
}
